export const tailwindConfig = {
  screens: {
    s: { max: 640 },   // small screen
    xs: { max: 380 },   // extra small screen
    m: { max: 1350, min: 640 },   // medium screen
    ms: { max: 1350 },   // medium screen and small screen
  }
};
